<template>
  <div class="h-100 container">
    <part-base :form-data.sync="formData" :form-input="formInput" :is-operate="isOperate"
               :is-pre-executor="parseInt($route.query.isPreExecutor) === 1"
               :pt="parseInt($route.query.pt)"
               :show-add-btn="!!$route.query.id"
               @saved="editPage"
               @goBack="goBack"/>
  </div>
</template>

<script>
import PartBase from "./components/PartBase";

// 表单数据结构
const ModelFormData = {
  project_type:3,//普客订单=3
  company_id: null, // 乙方
  customer_name: '', //客户姓名
  customer_nature: '', //客户性质
  combine_brand_id:null,
  customer_id: '', // 客户ID
  customer_name_custom: null,
  exec_customer_id: null, // 执行公司id
  exec_customer_name: '', // 执行公司名称
  sale: '', //销售
  sale_id: '', // 销售ID
  executor: '', // 执行
  executor_id: '', // 执行ID
  brand: '', // 选中的代理品牌
  trade: '', // 行业
  product: '', // 产品
  order_source: '', // 订单来源
  cooperate_mode:'',//合作形式
  product_category: '', // 品类
  price_range: '', // 客单
  project_name: null,
  // strategy_name: null, // 策略人名
  // strategy_id: null, // 策略人ID
  // planner_name: null, // 策划人名
  // planner_id: null, // 策划人ID
  // medium_name: null, // 媒介人
  // medium_id: null, // 媒介人ID
  //其他
  order_type: 'regular', //订单类型：regular【普通订单】、strike【冲账订单】
  //折扣
  discount: '',
  //规则
  rule: ''
};
export default {
  name: "Create",
  components: {PartBase},
  data() {
    return {
      formData: {...{}, ...ModelFormData},
      formInput: true,
      isOperate: 0,
    }
  },
  computed: {
    tmpOrders() {
      return this.$ls.get('tmpOrders') || []
    },
  },
  async created() {
    //合作形式读取
    const query = this.$route.query
    if (query.cooperation) {
      this.formData.form_of_cooperation = query.cooperation || ''
      this.$notify.info(`新增项目（${this.formData.form_of_cooperation}）`)
    }
    //暂存订单数据读取
    let tempIndex = this.$route.query && this.$route.query.tmpIndex
    if (this.tmpOrders[tempIndex]) {
      this.formData = this.tmpOrders[tempIndex]
    }
  },
  methods: {
    goBack() {
      this.$router.push({name: "ad_regulars"});
    },
    editPage(id) {
      const {href} = this.$router.resolve({
        name: 'editAdOrderRegulars',
        params: { id: id },
        query: { isPreExecutor: 1, pt: parseInt(this.$route.query.pt) }
      });
      this.$router.replace(href)
    }
  }
}
</script>

<style scoped>

</style>
